import { createColumnHelper } from "@tanstack/react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";

import { convertDateToMonthDayYearFormat } from "../../../../shared";
import {
  messageType,
  PAGINATION_INDEXING,
  PAGINATION_PAGE_SIZES,
} from "../../constants";

const columnHelper = createColumnHelper();

/**
 * Request body for marketing attribution graph / paginated APIs.
 */
export const buildMarketingAttributionRequestBody = ({
  pageNumber = PAGINATION_INDEXING.FIRST_PAGE_INDEX,
  pageSize = PAGINATION_PAGE_SIZES.DEFAULT,
  groupId,
  brandId,
  storeId,
  toTime,
  fromTime,
}) => ({
  pageNumber,
  pageSize,
  groupId,
  brandId,
  storeId,
  toTime,
  fromTime,
});

/**
 * Transform graph API rows into ApexChart [[header], ...data] shape.
 */
export const transformMarketingAttributionChartData = (
  graphData,
  daysHeader,
  ordersHeader
) => {
  const result = [[daysHeader, ordersHeader]];
  const transformedData = [...(graphData || [])].map(
    ({ daysAfterMarketing, noOfOrders }) => [daysAfterMarketing, noOfOrders]
  );
  return result.concat(transformedData);
};

//static headers for data table
export const marketingAttributionReportColumns = (
  setMarketingAttributionReportBodyModal
) => {
  return [
    columnHelper.accessor("restaurantTitle", {
      header: () => "Store",
    }),
    columnHelper.accessor("id", {
      header: () => "Id",
    }),
    columnHelper.accessor("customer", {
      header: () => "Customer",
    }),
    columnHelper.accessor("sendTo", {
      header: () => "Contact Info",
    }),
    columnHelper.accessor("messageType", {
      header: () => "Message Type",
      cell: ({ row: { original } }) => messageType[original.messageType],
    }),
    columnHelper.accessor("deliveryDate", {
      header: () => "Message Sent",
      cell: ({ row: { original } }) =>
        convertDateToMonthDayYearFormat(original.deliveryDate),
    }),
    columnHelper.accessor("orderPlaced", {
      header: "Order Placed",
      cell: ({ row: { original } }) =>
        convertDateToMonthDayYearFormat(original.orderPlaced),
    }),
    columnHelper.accessor("daysAfterMarketing", {
      header: "Days After Marketing",
      cell: ({ getValue, row: { original } }) => (
        <div className="d-flex justify-content-center align-items-center gap-3">
          <span>{getValue()}</span>
          <FontAwesomeIcon
            icon={faEye}
            data-testid="edit-icon"
            onClick={() => {
              setMarketingAttributionReportBodyModal(original);
            }}
          />
        </div>
      ),
    }),
  ];
};
